import React from "react";
import { format } from "date-fns";

const EventTeaser = ({ event }) => {
    const eventStartDate = new Date(event.startDate * 1000);
    let eventEndDate = null;

    if (event.endDate) {
        eventEndDate = new Date(event.endDate * 1000);
    }

    return (
        <div className="event-teaser">
            {event.image && (
                <a href={event.url} className="event-teaser__image" style={{ backgroundImage: `url('${event.image}')` }}>
                    {event.isHighlight && (
                        <div className="event-teaser__highlighted">
                            In de kijker
                        </div>
                    )}
                </a>
            )}
            <div className="event-teaser__content">
                <div className="event-teaser__date">
                    <div className="event-teaser__date-icon" />
                    {format(eventStartDate, "dd.MM.yyyy")}
                    {eventEndDate && format(eventStartDate, "dd.MM.yyyy") !== format(eventEndDate, "dd.MM.yyyy") && (
                        <>
                            {" - "}
                            {format(eventEndDate, "dd.MM.yyyy")}
                        </>
                    )}
                </div>
                <a href={event.url} className="event-teaser__title-wrapper">
                    <h3 className="event-teaser__title">
                        {event.title}
                    </h3>
                </a>
                <p className="event-teaser__text" dangerouslySetInnerHTML={{ __html: event.organiser }} />
            </div>
        </div>
    );
};

export default EventTeaser;
